<div class="flex flex-col justify-center items-center ">
    <div class="card">
        
        <app-loading-animation *ngIf="!ready" class="w-full"></app-loading-animation>

        <div *ngIf="ready" class="w-full flex flex-wrap gap-3">


            <div class=" w-full lg:w-1/2 grow flex flex-col justify-stretch gap-7">
                <h2 class="text-colored">Informazioni utente <b>{{user?.username}}</b></h2>

                <div class="card-primary rounded-2xl shadow-md w-full flex flex-col gap-4">
                    <div>
                        <h4 class="font-bold text-colored">Nome</h4>
                        <p>{{user?.firstName || "Non specificato"}}</p>
                    </div>
                    <div>
                        <h4 class="font-bold text-colored">Cognome</h4>
                        <p>{{user?.lastName || "Non specificato"}}</p>
                    </div>
                    <div>
                        <h4 class="font-bold text-colored">Email</h4>
                        <p>{{user?.email }}</p>
                    </div>
            
                    <div>
                        <h4 class="font-bold text-colored">Ruoli</h4>
                        <!-- <p>
                            <span *ngFor="let role of session?.role, let i = index">{{role}}<span *ngIf="i < session?.role!.length -1">, </span></span>
                        </p> -->
                    </div>
                    <div>

                        <p class="text-colored">Data creazione account: {{user?.createdAt| date}}</p>
                        <!-- <p class="text-colored">Ultima modifica: {{user?.editDate | date}}</p> -->
                    </div>

                </div>
            </div>

            <!-- <div class="w-full lg:w-1/3 flex flex-col gap-7">


                <h2 class="text-colored font-bold">Clienti collegati</h2>

                <div *ngIf="userAnagrafiche.clientiuser.length > 0">
                    <div class="card-primary flex justify-between w-full"
                        *ngFor="let singleAcus of userAnagrafiche.clientiuser">

                        <h4 class="my-auto">
                            {{singleAcus.descrizione}}
                        </h4>

                    </div>

                </div>


                <div class="card-primary flex justify-between w-full"
                    *ngIf="userAnagrafiche.clientiuser.length == 0">

                    <h4 class="my-auto font-bold">Nessun cliente collegato</h4>

                </div>
            </div> -->

        </div>

    </div>



</div>



<!-- (onNoSubmitClick)="back($event)" (onFieldChangeEmitter)="checkField($event)"  -->